import React from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ErrorCard from "../components/ErrorCard";
import SuccessCard from "../components/SuccessCard";

const validationSchema = Yup.object({
  emailAddress: Yup.string()
    .email("Adres e-mail jest niepoprawny!")
    .required("Adres e-mail jest wymagany!"),
  description: Yup.string()
    .min(10, "Opis problemu jest zdecydowanie za krótki!")
    .required("Opis problemu jest wymagany!"),
});

export default function Support() {
  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(null);

  const formik = useFormik({
    initialValues: {
      emailAddress: "",
      description: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "/api/AddHelpIssue",
          values,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status >= 200 && response.status < 300) {
          setSuccess({
            alert: "Poprawnie przesłano formularz",
            description: "W naszym systemie Twoje zgłoszenie otrzymało numer:",
            pre: response.data.key,
          });
          resetForm();
        } else {
          throw new Error("Nieoczekiwana odpowiedź serwera");
        }
      } catch (error) {
        setError(
          error.response?.data?.message ||
            "Wystąpił błąd podczas wysyłania zgłoszenia."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <Typography variant="h2">Pomoc techniczna</Typography>
      <Typography variant="body1">
        Masz problem techniczny? Nie możesz wsyłać zgłoszenia przekroczenia
        granic? Nie widzisz zgłoszeń, w których uczestniczysz? Wypełnij poniższy
        formularz.
      </Typography>
      {error && <ErrorCard error={error} />}
      {success && (
        <SuccessCard
          alert={success.alert}
          description={success.description}
          pre={success.pre}
        />
      )}
      {error === null && success === null && (
        <Box component="form" onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            variant="filled"
            label="Adres e-mail"
            name="emailAddress"
            type="email"
            margin="normal"
            value={formik.values.emailAddress}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            helperText={
              formik.touched.emailAddress && formik.errors.emailAddress
                ? formik.errors.emailAddress
                : "Twój adres e-mail zostanie wykorzystany do kontaktu z Tobą w celu rozwiązania problemu."
            }
            error={
              formik.touched.emailAddress && Boolean(formik.errors.emailAddress)
            }
          />

          <TextField
            fullWidth
            variant="filled"
            label="Treść wiadomości"
            name="description"
            multiline
            rows={4}
            margin="normal"
            placeholder="Opisz szczegółowo co się dzieje. Wskaż w jaki sposób możemy odtworzyć problem podczas jego weryfikacji. Podaj kroki, które należy wykonać by wystąpił problem."
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.description && Boolean(formik.errors.description)
            }
            helperText={formik.touched.description && formik.errors.description}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={formik.isSubmitting}
            sx={{
              backgroundColor: "#850C70",
              "&:hover": {
                backgroundColor: "#5F0054",
              },
              mt: 2,
            }}
          >
            Wyślij
          </Button>
          <Button
            onClick={formik.handleReset}
            variant="outlined"
            sx={{
              ml: 2,
              mt: 2,
              borderColor: "#850C70",
              color: "#850C70",
              "&:hover": {
                backgroundColor: "#5F0054",
                color: "#fff",
                borderColor: "#5F0054",
              },
            }}
          >
            Anuluj
          </Button>
        </Box>
      )}
    </>
  );
}
